import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/ui/SEO';
import Button from '../components/ui/Button';
export default function NotFound() {
  return <main className="min-h-screen bg-white" data-id="element-670" data-mp="105usektx5x83">
      <SEO title="Page Not Found | Medicolegal Psychiatry" description="The page you requested could not be found. Browse psychiatric expert witness services or contact Dr Syed to discuss an instruction." path="/404" noindex data-id="element-671" data-mp="10538i79opnxn" />
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-672" data-mp="1f23q3hy5w2ie">
        <div className="container mx-auto px-4" data-id="element-673" data-mp="1ju3ylysas3ql">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-674" data-mp="1judnfj1lw4up">
            Page Not Found
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-center" data-id="element-675" data-mp="1sujuam2su6kw">
            The page you requested is no longer available or the address was
            mistyped.
          </p>
        </div>
      </section>
      <section className="py-12" data-id="element-676" data-mp="1nvlwh75iqyr8">
        <div className="container mx-auto px-4" data-id="element-677" data-mp="1nwn6r9epnh7w">
          <div className="max-w-3xl mx-auto text-center" data-id="element-678" data-mp="1iwr2d923pnrt">
            <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-679" data-mp="1iv7lbg8mf8oz">
              Where to next
            </h2>
            <p className="text-slate mb-8 leading-relaxed" data-id="element-680" data-mp="1ex9wwfmocqmn">
              You can return to the home page, review the psychiatric expert
              witness services available, or send the details of an instruction
              directly.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-681" data-mp="22lt2uoi94rbk">
              <Button variant="primary" href="/" data-id="element-682" data-mp="1xtrvngzxxqse">
                Return to home
              </Button>
              <Button variant="secondary" href="/services" data-id="element-683" data-mp="1sv6sb8pe6qzq">
                View all services
              </Button>
              <Button variant="secondary" href="/contact" data-id="element-684" data-mp="2qakp6z95ufgf">
                Discuss an instruction
              </Button>
            </div>
            <p className="text-slate text-sm mt-8" data-id="element-685" data-mp="2lib35ub61zjf">
              A full list of pages is available on the{' '}
              <Link to="/sitemap" className="text-primary font-medium underline hover:text-secondary" data-id="element-686" data-mp="34hxpzpznk4rc">
                sitemap
              </Link>
              .
            </p>
          </div>
        </div>
      </section>
    </main>;
}